import { HTTP_AP_LoadAdvisorUserData_Response } from '@api-new/userservice';
import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared-lib/models/error.model';
import { PlatformTypeEnum } from '@shared/enums/platform-type.enum';

export const setInitialPlatformType = createAction('[PLATFORM] Set Initial Platform Type');
export const setPlatformType = createAction('[PLATFORM] Set Platform Type', props<{ platformType: PlatformTypeEnum }>());

export const loadAdvisorUserData = createAction('[PLATFORM] Load Advisor User Data');
export const loadAdvisorUserDataSuccess = createAction(
  '[PLATFORM] Load Advisor User Data Success',
  props<{ response: HTTP_AP_LoadAdvisorUserData_Response }>(),
);
export const loadAdvisorUserDataFailure = createAction('[PLATFORM] Load Advisor User Data Failure', props<{ error: ErrorModel }>());
